import React, { useState, useEffect } from "react";
import Meta from "./../components/Meta";
import DashboardSection from "./../components/DashboardSection";
import { requireAuth } from "./../util/auth";
import { useAuth } from "./../util/auth";
import CtaSection2 from "./../components/CtaSection2";
import Navbar from "../components/Navbar";
import Airtable from "airtable";

function DashboardPage(props) {
  const [link, setLink] = useState("/steps");
  const [email, setEmail] = useState();
  const auth = useAuth();

  const base = new Airtable({ apiKey: "keyYszkZ96pQMUvSj" }).base(
    "apprxa9ij9jvqdF7j"
  );

  useEffect(() => {
    base("Users")
      .select({
        view: "Grid view",
        filterByFormula: `{Email} = '${auth.user.email}'`,
      })
      .firstPage(function (err, records) {
        if (err) {
          console.error(err);
          return;
        }
        records.forEach(function (record) {
          console.log("Retrieved", record.id);
          setEmail(record.get("Email"));
          if (email) {
            setLink("/bookappt");
          }
        });
      });
  }, [auth.user.email, base, email]);

  return (
    <>
      <Meta title="Dashboard" />
      <Navbar
        color="default"
        logo="https://drive.google.com/uc?export=view&id=1idL8ixbXPQ6cFrmYenBkUfmz2X9_MkFi"
        logoInverted="https://drive.google.com/uc?export=view&id=1FDW3ksZ8tqRXneFsRPHFN4Gor8X1kfEA"
      />
      <CtaSection2
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Have you booked your free assessment?"
        buttonText="Book my assessment"
        buttonColor="primary"
        buttonPath={link}
      />
      <DashboardSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Dashboard"
        subtitle=""
      />
    </>
  );
}

export default requireAuth(DashboardPage);
